import "./Loading.css";

const Loading = () => {
  return (
    <>
      <div style={{ height: 300 }}></div>
      <div className="loading-steam">
        <span className="steam steam1"></span>
        <span className="steam steam2"></span>
        <span className="steam steam3"></span>
      </div>
    </>
  );
};

export default Loading;
